import React from "react";
import { ReservationFinished } from "../components/ReservationFinished";

/**
 * Wrapper for message component shown after submision with logic for checking validity of the appointment.
 */
export const AppointmentReservationFinished = () => {
  return <ReservationFinished />;
};
